<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 13" fill="none">
<line x1="6.52344" y1="11.8203" x2="6.52344" y2="1.17969" stroke="var(--faq-icon-color)" stroke-width="2" stroke-linecap="round"/>
<line x1="1.5" y1="6.20215" x2="12.1406" y2="6.20215" stroke="var(--faq-icon-color)" stroke-width="2" stroke-linecap="round"/>
</svg>
</template>
